module.exports = __webpack_public_path__ + "r-v3/img/ico_voiceRequest_white.8073809d.svg";